export const googlePlacesApiKey = __GOOGLE_PLACES_API_KEY__;

export const googlePlacesFieldProps = {
  showGooglePlaces: !!googlePlacesApiKey,
  googlePlacesApiKey,
};
